<template>
  <div class="grow overflow-y-auto">
    <template v-for="(item, index) in source.data" :key="item.id">
      <div class="contain-content">
        <slot name="row" :item="item" :index="index"></slot>
      </div>
    </template>

    <slot name="footer"></slot>
  </div>
</template>

<script setup lang="ts" generic="Model extends GenericModel">
import type { NormalizedDataSource } from "@/types/data-source";
import type { GenericModel } from "@/types/model";

import type { RowProps } from "./list-types";

defineProps<{
  source: NormalizedDataSource<Model>;
}>();

defineSlots<{
  row(props: RowProps<Model>): unknown;
  footer(props: {}): unknown;
}>();
</script>
